(function () {

    let isBound = false;

    function getMOQ() {
        const el = document.getElementById('product-moq');
        return el ? parseInt(el.dataset.moq, 10) || 1 : 1;
    }

    function getElements() {
        const wrapper = document.querySelector('quantity-input');
        if (!wrapper) return {};

        return {
            wrapper,
            input: wrapper.querySelector('input[name="quantity"]'),
            plus: wrapper.querySelector('.plus'),
            minus: wrapper.querySelector('.minus'),
        };
    }

    function enforceMOQ() {
        const moq = getMOQ();
        const { input } = getElements();
        if (!input || !moq) return;

        if (parseInt(input.value || 0, 10) < moq) {
            input.value = moq;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        input.min = moq;
        input.dataset.min = moq;
    }

    function bindButtons() {
        if (isBound) return;

        const moq = getMOQ();
        const { input, plus, minus } = getElements();
        if (!input || !plus || !minus) return;

        plus.addEventListener('click', () => {
            input.value = parseInt(input.value || moq, 10) + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        minus.addEventListener('click', () => {
            const next = parseInt(input.value || moq, 10) - 1;
            input.value = Math.max(next, moq);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        input.addEventListener('blur', () => {
            if (parseInt(input.value || 0, 10) < moq) {
                input.value = moq;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        isBound = true;
    }

    function showMOQMessage() {
        const moq = getMOQ();
        const { input } = getElements();
        if (!input || !moq) return;

        const container = input.closest('.quantity__container');
        if (!container) return;
        if (container.nextElementSibling?.classList.contains('moq-msg')) return;

        const msg = document.createElement('div');
        msg.className = 'moq-msg';
        msg.style.color = 'red';
        msg.style.marginTop = '6px';
        msg.textContent = `Minimum order quantity is : ${moq}`;
        container.parentNode.insertBefore(msg, container.nextSibling);
    }


    function init() {
        enforceMOQ();
        bindButtons();
        showMOQMessage();
    }

    document.addEventListener('DOMContentLoaded', init);

    new MutationObserver(() => {
        if (!document.querySelector('.moq-msg')) init();
    }).observe(document.body, { childList: true, subtree: true });

})();

//Add to cart with MOQ enforcement

(function () {

  async function addToCart(variantId, qty, properties = {}) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        properties: properties
      }),
    }).then(r => r.json());
  }

  async function refreshCart() {
    document.dispatchEvent(new Event('cart:updated'));
    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:change'));
    document.body.dispatchEvent(new Event('cart:open'));
  }

  function getMOQ(productCard) {
    if (!productCard) return 1;
    const moq = parseInt(productCard.dataset.moq, 10);
    return isNaN(moq) || moq < 1 ? 1 : moq;
  }

  function getQty(form, moq) {
    const input = form.querySelector('input[name="quantity"]');
    if (!input) return moq;
    let val = parseInt(input.value, 10);
    if (isNaN(val) || val < moq) val = moq;
    input.value = val;
    return val;
  }

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('button, [data-btn-addToCart]');
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productCard = form.closest('[data-moq]');
    const moq = getMOQ(productCard);

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    btn.disabled = true;
    const originalText = btn.innerHTML;
    const qty = getQty(form, moq);
    btn.innerHTML = `Adding ${qty}…`;

    // ---------------- Printing Options ----------------
    let properties = {};
    const printingSelect = (productCard && productCard.querySelector('#printing_option')) || document.querySelector('#printing_option');

    if (printingSelect) {
      const selected = printingSelect.selectedOptions[0];
      if (!selected) {
        alert('Please select a printing option');
        btn.disabled = false;
        btn.innerHTML = originalText;
        return;
      }
      const printingName = selected.value;
      const printingPrice = Number(selected.dataset.price || 0).toFixed(2);
      properties = {
        'Printing Option': printingName,
        'Printing Price': printingPrice,
        '_printing_total': (printingPrice * qty).toFixed(2)
      };
    }

    try {
      await addToCart(variantInput.value, qty, properties);
      await refreshCart();
      const drawerBtn = document.querySelector('[data-cart-toggle]') || document.querySelector('[href="/cart"]');
      if (drawerBtn) drawerBtn.click();
      else window.location.href = '/cart';

    } catch (err) {
      alert('Unable to add product');
      console.error(err);
    } finally {
      btn.disabled = false;
      btn.innerHTML = originalText;
    }
  }, true);

})();

